/** Belege und Aussteller (Paket 3). PDFs/CSV öffnet der Browser über dateiUrl(). */
import { api, post } from '../api';
import { liste, put, qs } from './http';
import type { AusstellerAenderung, AusstellerZeile, BelegExportStatus, BelegZeile, DocumentKopf } from './typen';

export const belege = (f: { art?: string; von?: string; bis?: string; test?: string; q?: string; order_id?: string }) => liste<BelegZeile>(`/belege${qs(f)}`);
export const belegExportStatus = (id: string) => api<BelegExportStatus>(`/belege/${id}/export-status`);
export const belegPdfPfad = (id: string) => `/belege/${id}/pdf`;
export const labelPdfPfad = (parcelId: string) => `/labels/${parcelId}.pdf`;
export const labelZplPfad = (parcelId: string) => `/labels/${parcelId}.zpl`;
export const csvPfad = (von: string, bis: string) => `/belege/export.csv${qs({ von, bis })}`;
/** R49 (W12): nur für Erstattungen außerhalb von WooCommerce. */
export type ErstattungswegT = 'ueberweisung' | 'paypal_direkt' | 'bar' | 'verrechnung' | 'sonstiges';
export const gutschriftAnlegen = (orderId: string, d: { betrag_cents: number; grund: string; erstattungsweg: ErstattungswegT; ausserhalb_woo: true; doppelt_bestaetigt?: boolean }) =>
  post<DocumentKopf>(`/auftraege/${orderId}/gutschrift`, d);
export const rechnungAnlegen = (orderId: string) => post<DocumentKopf>(`/auftraege/${orderId}/rechnung`, {});

export const aussteller = () => api<AusstellerZeile[]>('/aussteller');
/** Admin. Wirkt nur auf neue Belege (festgeschriebene bleiben unverändert, GoBD). */
export const ausstellerAendern = (id: string, d: AusstellerAenderung) => put<AusstellerZeile>(`/aussteller/${id}`, d);

/** R105: Nummernkreise je Aussteller (Format, Präfix, Startwert); ändern nur Admin und nur ohne Live-Beleg im Kreis. */
export interface NummernkreisStand {
  kreis: 'RE' | 'GS' | 'LS'; format: 'jahr' | 'fortlaufend'; praefix: string; start: number | null; gesperrt: boolean;
  letzte_live: string | null; naechste_live: string | null;
}
export const nummernkreise = (issuerId: string) => api<NummernkreisStand[]>(`/aussteller/${issuerId}/nummernkreise`);
export const nummernkreisSetzen = (issuerId: string, kreis: 'RE' | 'GS', d: { format: 'jahr' | 'fortlaufend'; praefix?: string; start?: number | null }) =>
  put<NummernkreisStand>(`/aussteller/${issuerId}/nummernkreise/${kreis}`, d);

export interface BelegHinweis {
  art: string;
  schwere: 'alarm' | 'warnung';
  text: string;
  link: string | null;
  id: string | null;
  order_id: string | null;
  seit: string | null;
}
/** Dashboard: Integrität (B6), Platzhalter-Aussteller (W6), Klärfälle der Belege (W3/W12). */
export const belegHinweise = () => api<{ hinweise: BelegHinweis[] }>('/belege/hinweise');

// ── Beleg-Klärfälle (W12, W3, N4/R65, R66): die Leitung entscheidet, StoreOS erzeugt nie still einen Beleg ──
export type BelegKlaerfallArt = 'doppelte_erstattung' | 'land_unbekannt' | 'erstattung_ueber_rechnung' | 'beleg_fehlgeschlagen';
export type BelegKlaerfallLoesung = 'gutschrift_erzeugen' | 'kein_beleg' | 'erledigt' | 'erneut' | 'gutschrift_rest' | 'sondergebiet_freigeben';
export interface BelegKlaerfall {
  id: string;
  order_id: string | null;
  bestellnummer: string | null;
  art: BelegKlaerfallArt;
  status: 'offen' | 'geloest';
  text: string;
  document_id: string | null;
  erstattung_referenz: string | null;
  betrag_cents: number | null;
  outbox_id: string | null;
  loesung: BelegKlaerfallLoesung | null;
  loesung_grund: string | null;
  loesung_steuerfall: string | null;
  geloest_at: string | null;
  created_at: string;
}
export const belegKlaerfaelle = (nurOffen = true) => api<{ klaerfaelle: BelegKlaerfall[] }>(`/belege/klaerfaelle${nurOffen ? '?offen=1' : ''}`);
/** Leitung. Grund Pflicht (mind. 5 Zeichen), `steuerfall` nur bei `sondergebiet_freigeben`. */
export const belegKlaerfallLoesen = (id: string, d: { aktion: BelegKlaerfallLoesung; grund: string; steuerfall?: string }) =>
  post<{ ok: boolean; document: DocumentKopf | null; neu_eingestellt: boolean }>(`/belege/klaerfaelle/${id}/loesen`, d);
